import React, { useState } from 'react'
import styled from 'styled-components'
import db from '../DataSource/Firebase';

const regexName = /^[A-Za-z ]+$/;
const regexEmail = /^((?=.{1,64}@)([^<>()\[\]\\.,;:^\^\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?![^@]{256})((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email



const ContactForm = () => {
  var validName = new RegExp(regexName);
  var validEmail = new RegExp(regexEmail);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit =()=>{
    if( validName.test(name) && validEmail.test(email) && msg !== ""){
      sendMessage();
    }
    else{
      alert("Please enter valid input.")
    }
  }

  const sendMessage = ()=>{
    db.collection("messages").add({
      name: name,
      email: email,
      message: msg
  })
  .then((docRef) => {
      // console.log("Document written with ID: ", docRef.id);
      setName("")
      setEmail("")
      setMsg("")
      alert("Message sent succefully")
  })
  .catch((error) => {
    alert("Something went wrong!")
  });
  }

  return (
    <Wrapper>
   <div className="modern-form">

<fieldset className='float-label-field'>
  <input id="txtName" type='text' placeholder='Your name' value={name}  onChange={(e) => setName(e.target.value)}></input>
</fieldset>
<fieldset className='float-label-field'>
  <input id="txtName" type='text' placeholder='Your email' value={email}   onChange={(e) => setEmail(e.target.value)}></input>
</fieldset>
{/* <fieldset className='float-label-field'> */}
  <textarea id="txtName" type='text' placeholder='Your message' value={msg}  onChange={(e) => setMsg(e.target.value)}></textarea>
{/* </fieldset> */}
</div>
<div>
  <button className='btn' onClick={handleSubmit}>Submit</button>
</div>

    </Wrapper>
  )
}

const Wrapper = styled.section`
/* background-color: red; */
.modern-form {
  width: 100%;
  /* margin: 30px auto; */
  background-color:  transparent;

  /* padding: 20px 10px; */
}
input{
  background-color: transparent;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  padding: 0.4rem;
  /* background-color: ; */
  color: white;
  ::placeholder{
    color: white;
    opacity: 0.7;
    padding: 0.4rem;
  }
};
textarea{
  width: 100%;
  height: 150px;
  /* padding: 12px 20px; */
  box-sizing: border-box;
  border: 1px solid white;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
  outline: none;
  color: white;
  padding: 0.4rem;
  background-color: transparent;
  ::placeholder{
    color: white;
    opacity: 0.7;
  }
}

.modern-form h3 {
  text-align: center;
}

.float-label-field {
  border: none;
  outline: none;
  position: relative;
  margin: 0 0 20px 0;
  padding: 0.4rem;
  border: 1px solid white;
  border-radius: 4px;
  /* box-sizing: border-box; */
}

.float-label-field input {
  border: none;
  outline: none;
  padding: 5px 5px 8px 0px;
  width: 100%;
  font-size: 18px;
  /* border-bottom: solid 1px #efefef;/ */
}

.float-label-field label {
  opacity: 0.5;
  position: absolute;
  top: 10px;
  left: 0px;
  transition: all 0.2s ease;
  font-size: 18px;
}

.float-label-field.focus label {
  color: orange;
}
.float-label-field.focus input {
  border-bottom: solid 1px orange;
}
.float-label-field.float label {
  opacity: 1;
  top: -8px;
  font-size: 60%;
  transition: all 0.2s ease;
  font-weight: bold;
}

.btn{
  
    background-color: white;
    border-radius: 3rem;
    /* width: 8rem; */
    /* height: 3rem; */
    color: blueviolet;
    border: 0px solid white;
    padding: 0.6rem;
    margin-top: 1rem ;
    margin-bottom: 1rem;
    width: 100%;
    :active{
      /* background-color: ; */
      opacity: 0.5;
    }

}

.form-container{
    display: flex;
    flex-direction: column ;

}
`

export default ContactForm